import { type Subscription, SubscriptionPlans } from "@prisma/client";

import {
  ENABLED_PLANS_BY_FEATURE,
  type Features,
} from "@musicfy/contants/Features";
import { hasEntitledSubscriptionStatus } from "@musicfy/utils/subscriptionEntitlement";

export const canUseFeature = (
  feature: Features,
  subscription: Subscription | null,
  options?: { isSubscriptionLoading?: boolean }
): boolean => {
  if (options?.isSubscriptionLoading) {
    return false;
  }

  if (!subscription) {
    return false;
  }

  const plan = subscription.plan || SubscriptionPlans.free;

  const isActiveSubscription = hasEntitledSubscriptionStatus(subscription);

  return (
    (ENABLED_PLANS_BY_FEATURE[feature]?.includes(plan) &&
      isActiveSubscription) ??
    false
  );
};
